<template>
  <el-card
    :body-style="{ padding: '0px' }"
    class="cheese-card">
    <!--
    <i class="edit el-icon-edit" @click="isEditing = true" />
    -->
    <img :src="`/static/${info.image || 'cheese-large-gray.png'}`">
    <div class="card-text">
      <h3>{{ info.name }}</h3>
      <div class="info">
        <div v-if="info.origin"><i class="el-icon-location-outline" />&nbsp;{{ info.origin }}</div>
        <div v-for="(date, index) in info.date" :key="index">
          <i class="el-icon-time" />&nbsp;{{ date }}
        </div>
      </div>
      <p>
        {{ info.description }}
      </p>
    </div>
    <div class="card-footer">
      <div
        v-if="hasRatings"
        class="ratings"
        @click="showRatings = !showRatings">
        <div v-if="showRatings">
          <el-rate
            v-for="[name, rating] in sortedRatings"
            :key="name"
            :value="rating"
            :score-template="`${name}`"
            disabled
            show-score />
        </div>
        <el-rate
          v-else
          :value="averageRating"
          :score-template="averageRating | toFixed(1)"
          disabled
          show-score />
        <i :class="showRatings ? 'el-icon-arrow-down' : 'el-icon-arrow-left'" />
      </div>
      <el-tag
        v-for="tag in info.tags"
        :key="tag"
        size="small">
        {{ tag }}
      </el-tag>
    </div>

    <el-dialog
      v-if="isEditing"
      :visible.sync="isEditing"
      title="Ret info om osten"
      class="edit-dialog">
      <edit-cheese-form ref="editForm" :data="info" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="isEditing = false">Annuller</el-button>
        <el-button type="primary" @click="saveEdit">Gem ændringer</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import EditCheeseForm from './EditCheeseForm.vue'

export default {
  components: {
    EditCheeseForm,
  },
  filters: {
    toFixed(val, digits) {
      return val.toFixed(digits)
    },
    lastValue(val) {
      if (Array.isArray(val)) {
        return val[-1]
      }
      return val
    },
  },
  props: {
    info: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      isEditing: false,
      showRatings: Object.keys(this.info.ratings).length <= 1,
    }
  },
  computed: {
    hasRatings() {
      return Object.keys(this.info.ratings).length > 0
    },
    averageRating() {
      const ratings = Object.values(this.info.ratings)
      const ratingSum = ratings.reduce((sum, r) => sum + r, 0)
      return ratings.length ? ratingSum / ratings.length : undefined
    },
    sortedRatings() {
      const raters = Object.keys(this.info.ratings)
      raters.sort()
      return raters.map(r => [r, this.info.ratings[r]])
    },
  },
  methods: {
    saveEdit() {
      const newInfo = this.$refs.editForm.getData()
      this.$store.commit('updateCheese', {
        newInfo,
      })
      this.isEditing = false
    }
  },
}
</script>

<style>
.cheese-card {
  flex: 1 0 200px;
  max-width: 320px;
  margin: 12px;
  position: relative;
}

.cheese-card .edit {
  display: none;
  position: absolute;
  top: 12px;
  right: 12px;
  color: black;
  background: white;
  padding: 8px;
  border-radius: 100px;
  cursor: pointer;
  opacity: 0.4;
}

.cheese-card:hover .edit {
  display: inline-block;
}

.cheese-card .edit:hover {
  opacity: 1;
}

.cheese-card .el-tag {
  margin-right: 6px;
}

.cheese-card img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  background-color: #eee;
}

.el-card__body {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.card-text {
  flex: 1 0;
  padding: 12px;
  padding-bottom: 0;
  font-size: 90%;
  line-height: 1.3;
}
.card-text h3 {
  margin: 0 0 12px 0;
}
.card-text .info {
  font-size: 80%;
  color: #606266;
  line-height: 1.4;
}

.card-footer {
  padding: 12px;
  padding-top: 0;
  line-height: 1.8;
}

.cheese-card .ratings {
  margin-bottom: 12px;
}

.edit-dialog .el-dialog {
  width: auto;
  margin: 0 10px 20px 10px;
}
@media (min-width: 500px) {
  .edit-dialog .el-dialog {
    width: 50%;
    min-width: 480px;
    margin-left: auto;
    margin-right: auto;
  }
}

.edit-dialog .el-form-item__label {
  line-height: 14px;
}

.ratings {
  display: flex;
  cursor: pointer;
}

.ratings > :first-child {
  flex: 1 0 auto;
}

.ratings > i {
  color: #c0c4cc;
}
</style>



// WEBPACK FOOTER //
// src/components/CheeseCard.vue